import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, UserRound, Users, Settings } from "lucide-react";
import { useTrip } from "@/lib/store";
import { BottomSheet } from "./BottomSheet";

export function ProfileMenu({ dark = false }) {
  const { profile, setProfileId } = useTrip();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  if (!profile) return null;
  const Item = ({ Icon, label, sub, onClick, testId }) => (
    <button data-testid={testId} onClick={() => { setOpen(false); onClick(); }} className="tap flex w-full items-center gap-3 rounded-2xl bg-white p-4 text-left">
      <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[var(--jade-soft)] text-[var(--jade)]"><Icon className="h-5 w-5" /></span>
      <span><span className="block font-semibold">{label}</span><span className="block text-xs text-[var(--ink-muted)]">{sub}</span></span>
    </button>
  );
  return (
    <>
      <button data-testid="profile-indicator" onClick={() => setOpen(true)} className={`tap inline-flex h-10 items-center gap-2 rounded-full px-2 pr-3 text-sm font-semibold ${dark ? "bg-white/15 text-[var(--parchment)] backdrop-blur-md" : "border bg-white"}`}>
        <span className="flex h-7 w-7 items-center justify-center rounded-full font-display text-sm font-semibold text-white" style={{ background: profile.color }}>{profile.initial || profile.name[0]}</span>
        {profile.name} <ChevronDown className="h-3.5 w-3.5 opacity-70" />
      </button>
      <BottomSheet open={open} onClose={() => setOpen(false)} testId="profile-menu" eyebrow="Travelling as" title={profile.name}>
        <div className="mt-4 space-y-2">
          <Item Icon={UserRound} label="My profile" sub="Items and expenses are tagged with your name" onClick={() => navigate("/more/expenses")} testId="profile-menu-mine" />
          <Item Icon={Users} label="Switch traveller" sub="Choose who's using this phone" onClick={() => setProfileId(null)} testId="profile-menu-switch" />
          <Item Icon={Settings} label="Settings" sub="Currency, maps, offline copy, lock" onClick={() => navigate("/more/settings")} testId="profile-menu-settings" />
        </div>
      </BottomSheet>
    </>
  );
}
